import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'
import enTranslation from './locales/en.json'

const languages = {
  en: () => import('./locales/en.json'),
  it: () => import('./locales/it.json'),
  fr: () => import('./locales/fr.json'),
  de: () => import('./locales/de.json'),
  pl: () => import('./locales/pl.json'),
  es: () => import('./locales/es.json'),
}

export default i18n.use(initReactI18next).init({
  lng: 'en', 
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  resources: {en: {translation: enTranslation}} 
})

export const loadLanguage = async (lang) => {
  try {
    if (languages[lang]) {
      const translations = await languages[lang]()
      i18n.addResourceBundle(lang, 'translation', translations.default || translations)
      i18n.changeLanguage(lang)
    } else {
      loadLanguage('en')
      localStorage.setItem('language', 'en')
    }
  } catch (error) {
    console.error(error)
   
    // store.dispatch(setLanguageLoader(false))
  }
  
  // store.dispatch(setLanguageLoader(false))
}


export const langs = [
  "en",
  "it",
  "fr",
  "de",
  "pl",
  "es"
]

export const detectSetLanguage = async (setLoading) => {
	const savedLanguage = localStorage.getItem('language')
	if (savedLanguage) {
		await loadLanguage(savedLanguage.toLowerCase())
	} else {
		let baseLang = navigator.language.split('-')[0]

    console.log('langs.includes(baseLang.toLowerCase())',langs.includes(baseLang.toLowerCase()))

		if (langs.includes(baseLang.toLowerCase())) {
			await loadLanguage(baseLang);
			localStorage.setItem('language', baseLang.toLowerCase())
		} else {
			await loadLanguage('en'); 
			localStorage.setItem('language', 'en')
		}
	}

	setLoading(false)
}
